module.exports = __webpack_public_path__ + "static/BuildingFacadeFull-4840e413f541621755161c64070b2caa.jpg";